import { demoActiveGuestData, demoAnalyticsData } from './demoData'

export default function autoinvite(
  state = {
    activeGuestData: null,
    optedoutGuestData: null,
    uploadLogsData: [],
    activeSubscriptionCount: '',
    optedOutCount: '',
    analyticsData: null,
    demoAnalyticsData,
    demoActiveGuestData,
    updatedOn: null,
    isLoading: true
  },
  action
) {
  switch (action.type) {
    case 'SAVE_POSTED_SUBSIDIARY':
      return {
        ...state,
        uploadLogsData: []
      }
    case 'GOT_ACTIVE_GUESTS':
      return {
        ...state,
        activeGuestData: action.payload
      }
    case 'GOT_ALL_GUESTS':
      return {
        ...state,
        allGuestsData: action.payload.subscribers,
        optedoutGuestData: action.payload.result,
        activeSubscriptionCount: action.payload.activeSubscriptionCount,
        optedOutCount: action.payload.optedOutCount
      }
    case 'GOT_OPTED_OUT_GUESTS':
      return {
        ...state,
        optedoutGuestData: action.payload.result,
        activeSubscriptionCount: action.payload.activeSubscriptionCount,
        optedOutCount: action.payload.optedOutCount
      }

    case 'GOT_UPLOAD_LOGS':
      return {
        ...state,
        uploadLogsData: action.payload.data,
        lastUpdated: action.payload.timestamp
      }
    case 'GET_ANALYTICS_STARTED': {
      return {
        isLoading: true
      }
    }
    case 'GET_ANALYTICS_FAILED': {
      return {
        isLoading: false
      }
    }
    case 'GOT_ANALYTICS':
      return {
        ...state,
        analyticsData: action.payload.analyticsData,
        updatedOn: action.payload.updatedOn,
        isLoading: false
      }

    case 'POST_AND_SELECT_SUBSIDIARY_STARTED': {
      return {
        ...state,
        analyticsData: null,
        updatedOn: null,
        isLoading: true,
        allGuestsData: []
      }
    }
    default:
      return {
        ...state
      }
  }
}
